import React, {Component} from "react";
import {connect} from "react-redux";
import {Redirect} from "react-router-dom";
import {LayoutSplashScreen} from "../../../../_metronic/layout";
import * as auth from "../_redux/authRedux";
const useSso = localStorage.getItem("useSso") ? JSON.parse(localStorage.getItem("useSso")) : false;

class Logout extends Component {
  componentDidMount() {
    localStorage.removeItem("user");
    this.props.logout();
  }

  render() {
    const { hasAuthToken } = this.props;
    return hasAuthToken ? <LayoutSplashScreen /> : useSso ? <Redirect to="/auth/walmart/sso" /> : <Redirect to="/auth/login"/>;
  }
}

export default connect(
  ({ auth }) => ({ hasAuthToken: Boolean(auth.authToken) }),
  auth.actions
)(Logout);
